import { useEffect } from 'react';
import { useLocation } from 'react-router';

import {
  useSearchActions,
  useSearchFiltersByName,
} from '#/modules/search/contexts/SearchContext';
import { resetRefinementUI } from '#/modules/search/helpers/refinements/searchRefinementsResetRefinementUI';
import type { SearchFacet } from '#/modules/search/types/SearchFacet';
import type { SearchType } from '#/modules/search/types/SearchType';

import type { SearchPageLocationState } from './types/SearchPageLocationState';
import { useSearchPageSyncUrlAndFetch } from './useSearchPageSyncUrlAndFetch';

type Args = {
  searchType: SearchType;
  getSearchTrackingData: () => Record<string, unknown>;
  searchFacets: SearchFacet[];
  isSearchLandingPage?: boolean;
};

export function useSearchPageLifecycle({
  searchType,
  getSearchTrackingData,
  searchFacets,
  isSearchLandingPage,
}: Args) {
  const { updateSearchLocation } = useSearchActions();
  const filtersByName = useSearchFiltersByName();
  const location = useLocation<SearchPageLocationState>();

  const locationStateSearchLocation = location.state?.searchLocation;

  useEffect(() => {
    if (filtersByName.type !== searchType) {
      resetRefinementUI();
    }
  }, [filtersByName, searchType]);

  useEffect(() => {
    if (locationStateSearchLocation)
      updateSearchLocation(locationStateSearchLocation, true);
  }, [locationStateSearchLocation, updateSearchLocation]);

  // Sync & fetch
  const { initialized } = useSearchPageSyncUrlAndFetch({
    searchType,
    getSearchTrackingData,
    searchFacets,
    isSearchLandingPage,
  });

  return { initialized };
}
